import React, { FC, useContext } from 'react'

import { Pagination as PaginationComponent } from '~shared-components/components/Pagination/Pagination'

import { ListPageContext } from './ListPage'

export interface PaginationProps {
  currentPage: number
  onPageChanged?(page: number): void
  totalPages: number
}

export const Pagination: FC<PaginationProps> = ({
  currentPage,
  onPageChanged,
  totalPages,
}) => {
  const { topRef } = useContext(ListPageContext)
  if (totalPages <= 1) return null
  return (
    <PaginationComponent
      currentPage={currentPage ? currentPage : 1}
      onGoToPage={pageNumber => {
        setTimeout(() => {
          const top = topRef?.current
            ? window.scrollY + topRef.current.getBoundingClientRect().top
            : undefined
          if (top) {
            window?.scrollTo({ behavior: 'smooth', top })
          }
        }, 300)
        onPageChanged?.(pageNumber)
      }}
      totalPages={totalPages}
    />
  )
}
Pagination.displayName = 'ListPage.Pagination'
